import { Box, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';
import { ScrollView } from 'react-native';

import { ScrollCloseToBottomProvider } from '../../contexts/ScrollCloseToBottom';
import { useScrollCloseToBottom } from '../../hooks/useScrollCloseToBottom';

import { MainReportGenerator } from './components/MainReportGenerator';
import { ReportGeneratorHeader } from './components/ReportGeneratorHeader';
import { reportGeneratorTheme } from './constants/theme';

export const ReportGenerator: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const pagePaddingTop = useBreakpointValue({
    base: Spacing['inset.xs'],
    sm: reportGeneratorTheme.page.paddingTop,
    lg: reportGeneratorTheme.page.paddingTop,
  });
  const pagePaddingBottom = useBreakpointValue({
    base: Spacing['inset.xs'],
    lg: reportGeneratorTheme.page.paddingTop,
  });
  const { isCloseToBottom, validateIsCloseToBottom } = useScrollCloseToBottom();

  return (
    <Box
      flex={1}
      minH={0}
      bg={reportGeneratorTheme.page.bg}
      px={{
        base: reportGeneratorTheme.page.paddingHorizontal.mobile,
        sm: reportGeneratorTheme.page.paddingHorizontal.tablet,
        lg: reportGeneratorTheme.page.paddingHorizontal.desktop,
      }}
      overflow="hidden">
      <ScrollView
        style={{ flex: 1, backgroundColor: reportGeneratorTheme.page.bg }}
        contentContainerStyle={{
          paddingTop: pagePaddingTop,
          paddingBottom: pagePaddingBottom,
        }}
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={200}
        onScroll={({ nativeEvent }) => validateIsCloseToBottom(nativeEvent)}>
        <ScrollCloseToBottomProvider isCloseToBottom={isCloseToBottom}>
          <Box
            width="full"
            maxWidth={{ base: '100%', sm: '95%', lg: '1280px' }}
            minWidth={0}
            alignSelf="center">
            <VStack space={isMobile ? 'stack.xxxs' : 'stack.xxs'}>
              <ReportGeneratorHeader />

              <MainReportGenerator />
            </VStack>
          </Box>
        </ScrollCloseToBottomProvider>
      </ScrollView>
    </Box>
  );
};
